import { callApi } from '../../../../apiCaller';
import { DEFAULT_FN } from '../../../../constants';
import { sortArrayByProperty, toastError } from '../../../../utils';

const API_SYSTEM_ADMIN_LIST_ORGANIZATION_OPTIONS = '/organization/list-organization-training-reports';
const API_SYSTEM_ADMIN_LIST_PRODUCT_OPTIONS = '/products/organization-training-reports/get-list-product';
const API_SYSTEM_ADMIN_LIST_UPCOMING_EVENT_OPTIONS = '/products/organization-training-reports/upcoming-event';
const API_SYSTEM_ADMIN_LIST_TRAINING_DATE_EVENT_OPTIONS = '/products/organization-training-reports/training-date';
const API_SYSTEM_ADMIN_GET_ORGANIZATION_TRAINING_REPORTS = '/organization-training-reports';
const API_SYSTEM_ADMIN_EXPORT_EXCEL_ORGANIZATION_TRAINING_REPORTS = '/organization-training-reports/export-excel';

export const fetchListOrganizationOptions = (filterReport, setOrganizationOptions, setIsLoading) => () => {
     setIsLoading(true);
     const page = 1;
     const pageSize = 20;
     const sortBy = '';
     const sortType = '';
     const filterQuery = Object.keys(filterReport).length ? `&filter=${encodeURIComponent(JSON.stringify(filterReport))}` : '';
     const endpoint = `${API_SYSTEM_ADMIN_LIST_ORGANIZATION_OPTIONS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;
     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const orgs = response.data.map((org) => ({
                    value: org.id,
                    label: org.name,
                    productIds: org.organizationProducts.map((item) => item.productId),
               }));
               sortArrayByProperty(orgs, 'label', 'asc');
               setOrganizationOptions(orgs);
          })
          .finally(() => {
               setIsLoading(false);
          });
};
export const fetchListProductOptions = (filterReport, setProductOptions, setIsLoading) => () => {
     setIsLoading(true);
     const page = 1;
     const pageSize = 20;
     const sortBy = '';
     const sortType = '';
     const filterQuery = Object.keys(filterReport).length ? `&filter=${encodeURIComponent(JSON.stringify(filterReport))}` : '';
     const endpoint = `${API_SYSTEM_ADMIN_LIST_PRODUCT_OPTIONS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;
     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const products = response.data.map((pro) => ({
                    value: pro.id,
                    label: pro.publishName,
               }));
               sortArrayByProperty(products, 'label', 'asc');
               setProductOptions(products);
          })
          .finally(() => {
               setIsLoading(false);
          });
};

export const fetchListUpcomingEventOptions = (filterReport, setUpComingEventOptions, setIsLoading) => () => {
     setIsLoading(true);

     const page = 1;
     const pageSize = 20;
     const sortBy = '';
     const sortType = '';
     const filterQuery = Object.keys(filterReport).length ? `&filter=${encodeURIComponent(JSON.stringify(filterReport))}` : '';
     const endpoint = `${API_SYSTEM_ADMIN_LIST_UPCOMING_EVENT_OPTIONS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;
     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const events = response.data.map((event) => ({
                    value: event.id,
                    label: event.name,
                    productIds: [event.productId],
               }));
               sortArrayByProperty(events, 'label', 'asc');
               setUpComingEventOptions(events);
          })
          .finally(() => {
               setIsLoading(false);
          });
};

export const fetchListTrainingDateOptions = (filterReport, setTrainingDateOptions, setIsLoading) => () => {
     setIsLoading(true);

     const page = 1;
     const pageSize = 20;
     const sortBy = '';
     const sortType = '';
     const filterQuery = Object.keys(filterReport).length ? `&filter=${encodeURIComponent(JSON.stringify(filterReport))}` : '';
     const endpoint = `${API_SYSTEM_ADMIN_LIST_TRAINING_DATE_EVENT_OPTIONS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;
     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const events = response.data.map((event) => ({
                    value: event.id,
                    label: event.startAt,
                    timezone: event.timezone,
                    productIds: [event.productId],
               }));
               sortArrayByProperty(events, 'label', 'asc');
               setTrainingDateOptions(events);
          })
          .finally(() => {
               setIsLoading(false);
          });
};

export const getOrganizationTrainingReports = (nextDispatch) => () => {
     const { setIsLoadingFilter = DEFAULT_FN, setReportPreview = DEFAULT_FN, paginationPayload } = nextDispatch;
     setIsLoadingFilter(true);
     const page = paginationPayload.page;
     const pageSize = paginationPayload.pageSize;
     const sortBy = paginationPayload?.sortBy || '';
     const sortType = paginationPayload?.sortType || '';
     const newFilterReport = paginationPayload.filter;

     const filterQuery = Object.keys(newFilterReport).length ? `&filter=${encodeURIComponent(JSON.stringify(newFilterReport))}` : '';
     const endpoint = `${API_SYSTEM_ADMIN_GET_ORGANIZATION_TRAINING_REPORTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;

     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               setReportPreview(response.data);
          })
          .finally(() => {
               setIsLoadingFilter(false);
          });
};

export const exportOrganizationTrainingReports = (nextDispatch) => () => {
     const { pagination, setIsLoadingExcel, setIsEmptyExcel } = nextDispatch;
     setIsLoadingExcel(true);
     const page = pagination.page;
     const pageSize = pagination.pageSize;
     const sortBy = pagination?.sortBy || '';
     const sortType = pagination?.sortType || '';
     const newFilterReport = pagination.filter;
     const filterQuery = Object.keys(newFilterReport).length ? `&filter=${encodeURIComponent(JSON.stringify(newFilterReport))}` : '';
     const endpoint = `${API_SYSTEM_ADMIN_EXPORT_EXCEL_ORGANIZATION_TRAINING_REPORTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;

     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               setIsEmptyExcel(!response.data);

               if (response.data) {
                    window.open(response.data);
               }
          })
          .finally(() => {
               setIsLoadingExcel(false);
          });
};
